// Companies that have used MR. BOSS & CO. for corporate gifting.
// Logos are pre-processed to plain white silhouettes (see
// /app/backend/scripts if more need adding) so they sit consistently
// against the dark house background regardless of each brand's own colour.
// More will be added over time — just append to this array.
export const TRUSTED_BY = [
  { name: 'Wise', logo: '/logos/wise.png' },
  { name: 'Accenture', logo: '/logos/accenture.png' },
  { name: 'PwC', logo: '/logos/pwc.png' },
  { name: 'Bridgepoint', logo: '/logos/bridgepoint.png' },
  { name: 'Knight Frank', logo: '/logos/knight-frank.png' },
  { name: 'Savills', logo: '/logos/savills.png' },
  { name: 'BNP Paribas', logo: '/logos/bnp-paribas.png' },
  { name: 'Radisson Blu', logo: '/logos/radisson-blu.png' },
  { name: 'The Lowry Hotel', logo: '/logos/lowry-hotel.png' },
  { name: 'Champneys Mottram Hall', logo: '/logos/mottram-hall.png' },
];
